import { AuthRoutes } from "@/features/auth";
import { ProfileRoutes } from "@/features/profile";
import { Navigate, RouteObject } from "react-router-dom";
import { routePaths } from "../config";

export const publicRoutes: RouteObject[] = [
  {
    path: routePaths.auth+"/*",
    element: <AuthRoutes/>,
  },
  { path: "*", element: <Navigate to={`${routePaths.auth}`} /> }
];
